import { createSelector } from "reselect"
import { map, pick } from "lodash"

const getPositionSets = (state, props) => props.positionSets

export const getItems = createSelector(
  [getPositionSets],
  (positionSets) => map(positionSets,
    (ps, index) => ({
      id: String(index),
      disabled: ps.isUnmodeled,
      ...pick(ps, ["label", "color", "noData", "isUnmodeled"]),
      type: ps.baseType || ps.type, // ResearchTopic item's types are all inline so we need the baseType
    })),
)
